var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.961,4.643c-1.878-.187-3.757-.327-5.647-.432V4.2l-.257-1.517C15.883,1.61,15.626,0,12.9,0H9.839C7.121,0,6.864,1.54,6.678,2.672L6.433,4.165c-1.085.07-2.17.14-3.255.245L.8,4.643A.873.873,0,1,0,.961,6.382l2.38-.233A93.017,93.017,0,0,1,21.8,6.393h.093a.884.884,0,0,0,.875-.793A.894.894,0,0,0,21.961,4.643Z",
    transform: "translate(2.621 1.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M16.8.443A1.435,1.435,0,0,0,15.765,0H1.421A1.416,1.416,0,0,0,.388.443,1.462,1.462,0,0,0,0,1.509l.7,11.643c.125,1.725.284,3.881,4.244,3.881h7.285c3.96,0,4.119-2.145,4.244-3.881l.7-11.632A1.471,1.471,0,0,0,16.8.443ZM10.476,11.348H6.7a.851.851,0,0,1,0-1.7h3.779a.851.851,0,1,1,0,1.7Zm.953-4.539H5.756a.851.851,0,0,1,0-1.7H11.43a.851.851,0,0,1,0,1.7Z",
    transform: "translate(5.407 9.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.ab1cacfd40ee598699d03d2a5d17a4a3.svg";
export { ForwardRef as ReactComponent };